import React, { useState } from "react";
import { useAuth } from '../authentication/AuthContext';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function AnimatorForm() {
    const { token } = useAuth(); // Use AuthContext to get the token
    const [formData, setFormData] = useState({
        name: "",
        first_name: "",
        email: "",
        location: "",
        is_admin: false,
        is_anim_serious_game: true,
        is_anim_workshop: true
    });
    const [loading, setLoading] = useState(false); // State for loading spinner

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleToggle = (field) => {
        setFormData({ ...formData, [field]: !formData[field] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Show spinner
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/create_account`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setFormData({
                    name: "",
                    first_name: "",
                    email: "",
                    location: "",
                    is_admin: false,
                    is_anim_serious_game: true,
                    is_anim_workshop: true
                });
                toast.success("Animateur créé avec succès !");
            } else {
                const errorData = await response.json();
                toast.error(`Erreur : ${errorData.message || "Une erreur est survenue."}`);
            }
        } catch (error) {
            toast.error("Erreur réseau. Veuillez réessayer.");
        } finally {
            setLoading(false); // Hide spinner
        }
    };

    return (
        <div className="animator-form-container">
            <h1 className="color-blue">Ajouter un animateur</h1>
            <form onSubmit={handleSubmit} className="animator-form">
                <div className="form-group">
                    <label htmlFor="name" className="color-blue">Nom</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-input"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="first_name" className="color-blue">Prénom</label>
                    <input
                        type="text"
                        id="first_name"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                        className="form-input"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email" className="color-blue">Adresse mail</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-input"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="location" className="color-blue">Localisation</label>
                    <input
                        type="text"
                        id="location"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        className="form-input"
                    />
                </div>
                <div className="form-group toggle-group">
                    <label className="color-blue">Administrateur ?</label>
                    <div className="toggle-container">
                        <input
                            type="checkbox"
                            id="is_admin"
                            name="is_admin"
                            checked={formData.is_admin}
                            onChange={() => handleToggle("is_admin")}
                            className="toggle-input"
                        />
                        <label htmlFor="is_admin" className="toggle-label"></label>
                    </div>
                </div>
                <div className="form-group toggle-group">
                    <label className="color-blue">Animateur plateforme BTP</label>
                    <div className="toggle-container">
                        <input
                            type="checkbox"
                            id="is_anim_serious_game"
                            name="is_anim_serious_game"
                            checked={formData.is_anim_serious_game}
                            onChange={() => handleToggle("is_anim_serious_game")}
                            className="toggle-input"
                        />
                        <label htmlFor="is_anim_serious_game" className="toggle-label"></label>
                    </div>
                </div>
                <div className="form-group toggle-group">
                    <label className="color-blue">Animateur plateforme Compte-Gouttes</label>
                    <div className="toggle-container">
                        <input
                            type="checkbox"
                            id="is_anim_workshop"
                            name="is_anim_workshop"
                            checked={formData.is_anim_workshop}
                            onChange={() => handleToggle("is_anim_workshop")}
                            className="toggle-input"
                        />
                        <label htmlFor="is_anim_workshop" className="toggle-label"></label>
                    </div>
                </div>
                <button type="submit" className="blue-button-admin" disabled={loading}>
                    {loading ? "Création de l'animateur..." : "Valider"}
                </button>
            </form>

            {/* Toast container here */}
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
        </div>
    );
}

export default AnimatorForm;
